// Site configuration & copy. Live standings come from the backend (/api/leaderboard).

export const SITE = {
  code: 'ASIANRISK',
  codeDisplay: 'ASIANRISK',
  roobetRef: 'https://roobet.com/?ref=Asianrisk',
  prizePool: 500,
  raceType: 'MONTHLY',
};

export const SOCIALS = {
  kick: 'https://kick.com/asianrisk',
  x: 'https://x.com/asianrisk_',
  instagram: 'https://www.instagram.com/asianrisk_/',
  discord: 'https://discord.gg/7c7RtmsAqA',
  beacons: 'https://beacons.ai/asianrisk',
};

export const PRIZE_SPLIT = [
  { rank: 1, prize: 225 },
  { rank: 2, prize: 125 },
  { rank: 3, prize: 85 },
  { rank: 4, prize: 45 },
  { rank: 5, prize: 20 },
];

// Weekly stream schedule in Europe/Amsterdam time, e.g. { day: 1, time: '20:00' } (0 = Sunday).
// Leave empty until a real schedule is confirmed — the "Next stream" line stays hidden.
export const STREAM_SCHEDULE = [];

// OWNER: fill in confirmed payout details. Any null field is hidden publicly and flagged at /?owner=1.
export const PAYOUT = {
  standingsFinal: null,
  howToClaim: null,
  claimDeadline: null,
  paymentMethod: null,
  paymentTimeframe: null,
  eligibility: null,
};

// OWNER: add real, verified results only. Section stays hidden while empty.
// Example: { month: 'September 2026', username: 'Ev*******3', place: 1, prize: 225, paid: true }
export const PAST_WINNERS = [];

export const REWARDS = [
  {
    key: 'rakeback',
    provider: 'Roobet',
    title: 'ROOBET RAKEBACK',
    icon: 'Coins',
    points: [
      'Register on Roobet with code ASIANRISK',
      'Rakeback is part of Roobet\u2019s own rewards program',
      'Rates and availability are set by Roobet, not AsianRisk',
    ],
    terms: [
      ['Provided by', 'Roobet'],
      ['Eligibility', 'Determined by Roobet and may depend on your account status, VIP level, and region.'],
      ['Calculation', 'Based on Roobet\u2019s rakeback rules for eligible wagers. AsianRisk does not set or change rates.'],
      ['Claiming', 'Claimed in your Roobet account according to Roobet\u2019s terms.'],
    ],
    cta: { label: 'OPEN ROOBET', type: 'roobet' },
  },
  {
    key: 'giveaways',
    provider: 'AsianRisk',
    title: 'COMMUNITY EVENTS',
    icon: 'Gift',
    points: [
      'Community events and giveaways are announced in Discord',
      'Each announcement includes its own rules',
      'Hang out with chat between streams',
    ],
    terms: [
      ['Provided by', 'AsianRisk'],
      ['Eligibility', 'Set per event and posted with each announcement in Discord.'],
      ['Claiming', 'Follow the instructions in the specific announcement.'],
    ],
    cta: { label: 'JOIN DISCORD', type: 'discord' },
  },
  {
    key: 'vip',
    provider: 'AsianRisk × Roobet',
    title: 'VIP TRANSFERS',
    icon: 'Crown',
    points: [
      'Apply to bring your VIP status from another casino',
      'Possible benefits after approval: dedicated host, rolling lossback, first-deposit bonus',
      'Every application is reviewed individually',
    ],
    terms: [
      ['Provided by', 'AsianRisk handles the application; benefits are delivered on Roobet.'],
      ['Approval', 'Approval is not guaranteed. Benefits apply only after your transfer is approved.'],
      ['Eligibility', 'Generally for players wagering around $100K\u2013$250K per month who can verify an existing casino VIP account.'],
      ['Rolling lossback', 'Up to 10%. The rate, calculation basis, and exclusions are confirmed in your ticket before approval.'],
      ['First-deposit bonus', 'Up to 10% on your first deposit after an approved transfer, replacing a standard welcome bonus. Terms are confirmed in your ticket.'],
      ['How to apply', 'Open a VIP ticket in Discord.'],
    ],
    cta: { label: 'VIEW VIP PROGRAM', type: 'vip' },
  },
];

export const STEPS = [
  { n: 1, title: 'Register With Code', text: 'Sign up on Roobet through the AsianRisk link and use code ASIANRISK so your account is linked to this leaderboard.', link: { label: 'Open Roobet', type: 'roobet' } },
  { n: 2, title: 'Check Eligible Activity', text: 'Leaderboard totals use qualifying wagers only. Wagers are weighted by game RTP under the published counting rules.', link: { label: 'Counting rules', href: '#leaderboard-rules' } },
  { n: 3, title: 'Follow The Standings', text: 'Standings refresh about every 60 seconds. Each race runs for one calendar month in UTC, with exact dates shown above the leaderboard.', link: { label: 'View leaderboard', href: '#leaderboard' } },
  { n: 4, title: 'Claim Your Prize', text: 'Once the race has closed, eligible top-five winners follow the prize payout process.', link: { label: 'Payout process', href: '#payouts' } },
];

export const DISCLOSURE = `Leaderboard wager amounts may differ from your statistics on Roobet, depending on the games you are playing:\n\u2022 Games with RTP of 97% or lower \u2192 100% of wager is counted\n\u2022 Games with RTP between 97.01% and 98.99% \u2192 50% of wager is counted\n\u2022 Games with RTP of 99% and over \u2192 10% of wager is counted\nAny abuse found by ASIANRISK or Roobet may result in your prize being forfeit.`;
